import { UIRouterModule } from "@uirouter/angular";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AssigneesModule } from "@webapp/assignees/assignees.module";
import { GridHeaderComponent } from "@webapp/home/components/grid-header/grid-header.component";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiCardModule } from "@webapp/ui/card/card.module";
import { UiChipModule } from "@webapp/ui/chip/chip.module";
import { UiGridModule } from "@webapp/ui/grid/grid.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiListModule } from "@webapp/ui/list/list.module";
import { UiSkeletonModule } from "@webapp/ui/skeleton/skeleton.module";
import { HomeSkeletonComponent } from "./components/home-skeleton/home-skeleton.component";
import { UserDetailsComponent } from "./components/user-details/user-details.component";
import { ViewMoreComponent } from "./components/user-details/view-more/view-more.component";

@NgModule({
  declarations: [GridHeaderComponent, HomeSkeletonComponent, UserDetailsComponent, ViewMoreComponent],
  imports: [
    CommonModule,
    UiButtonModule,
    UiIconModule,
    LocalizationModule,
    UiCardModule,
    UiSkeletonModule,
    UiListModule,
    UiGridModule,
    AssigneesModule,
    UiChipModule,
    UIRouterModule,
  ],
  exports: [GridHeaderComponent, HomeSkeletonComponent],
  providers: [],
})
export class HomeModule {}
